<template>
  <div class="banner-container"
       v-scroll="handleScroll">
    <home-banner :show="view === 'home-banner'"></home-banner>
    <about-banner :show="view === 'about-banner'"></about-banner>
    <Footer class="home-footer"></Footer>
  </div>
</template>

<script>

import Footer from '@/views/layout/Footer.vue'
import homeBanner from '@/components/homeBanner.vue'
import aboutBanner from '@/components/aboutBanner.vue'
import _ from 'lodash'

export default {
  name: 'home',
  data () {
    return {
      transitionName: 'home-fade',
      view: 'home-banner'
    }
  },
  methods: {
    handleScroll: _.debounce(
      function (val) {
        const nameOps = ['home-banner', 'about-banner']
        const length = nameOps.length
        const index = nameOps.indexOf(this.view)
        let resName = ''
        if (val === 'up') {
          resName = index === 0 ? nameOps[length - 1] : nameOps[index - 1]
        } else if (val === 'down') {
          resName = index === length - 1 ? nameOps[0] : nameOps[index + 1]
        }
        this.transitionName =
          resName === 'home-banner' ? 'home-fade' : 'about-fade'
        this.$nextTick(() => {
          this.view = resName
        })
      },
      300,
      {
        leading: true,
        trailing: false
      }
    )
  },
  components: {
    homeBanner,
    aboutBanner,
    Footer
  }
}
</script>

<style scoped lang="scss">
.banner-container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  background: url("../assets/BG.png") no-repeat center center fixed;
  background-size: cover;
}
.home-footer {
  position: fixed;
  bottom: 0;
  z-index: 2;
  left: 5%;
}
</style>
